import React, { useReducer, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getPage } from "../../api/page";
import { Helmet } from "react-helmet";
import Loading from "../../components/loading";
import { SinglePageContainer } from "./style";
import { FiArrowLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
const reducer = (state, action) => {
  switch (action.type) {
    case "SET_PAGE":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
const SinglePage = (props) => {
  const [state, dispath] = useReducer(reducer, { loading: true, data: {} });
  const params = useParams();
  useEffect(() => {
    if (params.slug) {
      getPage(params.slug).then((res) => {
        dispath({ type: "SET_PAGE", payload: res.data[0] });
      });
    }
  }, [params.slug]);
  return (
    <SinglePageContainer>
      <Loading loading={state.loading} />
      <Helmet>
        <title>
          {state.data.title && state.data.title.rendered
            ? state.data.title.rendered
            : null}
        </title>
      </Helmet>
      <div className="container">
        <div className="back">
          <Link to="/">
            <FiArrowLeft className="icon" />
          </Link>
        </div>
        <h2>
          {state.data.title && state.data.title.rendered
            ? state.data.title.rendered
            : null}
        </h2>
        {state.data.content && state.data.content.rendered ? (
          <div
            dangerouslySetInnerHTML={{ __html: state.data.content?.rendered }}
          />
        ) : null}
      </div>
    </SinglePageContainer>
  );
};
export default SinglePage;
